import Vue from "vue"
import Vuex from "vuex"
import modules from './modules'

Vue.use(Vuex);

export default new Vuex.Store({
    modules
})

//     //해당 파일이 관리하는 상태값입니다. state를 바꾸기 위해서는 commit을 이용해야 한다.
//     state: {
//         /* userInfos: {
//             name: '',
//             gender: '1', // 1:남, 2:여
//             birthday: '',
//             bmi: 0,
//             isTermsAgree1: false,
//             isTermsAgree2: false,
//             isTermsAgree3: false
//         }, */
//         userInfos: [],
//         customerCode: '',
//         checkupStep: ''
//     },
//     //state의 값을 직접 가져올 수 있지만 계산이 필요한 식의 경우 getters를 이용하여 가져올 수 있습니다.
//     getters: {
//         getCheckupStep: function (state) {
//             return state.checkupStep;
//         },
//         getUser: function (state) {
//             return state.userInfos;
//         }
//     },
//     // commit에 의해 실행됩니다.
//     mutations: {
//         setCustomerCode: function (state, payload) {
//             state.customerCode = payload;
//         },
//         setCheckupStep: function (state, payload) {
//             state.checkupStep = payload;
//         },
//         setUser: function (state, payload) {
//             state.userInfos = payload;
//             /* state.userInfos.push({
//                 name : payload.name,
//                 birthday : payload.birthday
//             }); */
//         }
//     },
//     //state를 바꾸기 위해 외부에서 commit을 호출합니다.
//     actions: {

//     }
// });
